//import * as overrideDates from 'z-override-dates'

class DeliveryCalculator {
  constructor() {
    this.currentRegion = 'us';
    this.container = document.getElementById('z-delivery-calculator');
    this.lastCutoffState = null;
    
    this.setupTimezoneHandling();
  }

  setupTimezoneHandling() {
    this.checkCutoffAndUpdate();
    setInterval(() => this.checkCutoffAndUpdate(), 60000);
    this.scheduleExactCutoffCheck();
  }

  scheduleExactCutoffCheck() {
    const et = this.getEasternTime();
    const targetHour = 14;
    const targetMinute = 0;
    
    let targetTime = new Date(et.time);
    targetTime.setHours(targetHour, targetMinute, 0, 0);
    
    if (et.time > targetTime) {
      targetTime.setDate(targetTime.getDate() + 1);
    }
    
    const msUntilTarget = targetTime - et.time;
    setTimeout(() => {
      this.checkCutoffAndUpdate();
      this.scheduleExactCutoffCheck();
    }, msUntilTarget);

    console.log(`Next cutoff check scheduled for: ${targetTime.toLocaleString()} ET`);
  }

  getEasternTime() {
    const etDate = new Date().toLocaleString('en-US', {
      timeZone: 'America/New_York',
      hour12: true,
      hour: 'numeric',
      minute: 'numeric'
    });
    
    const etTime = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
    
    //console.log('Current ET time:', etDate);
    //console.log('Local time:', new Date().toLocaleString());
    
    return {
      display: etDate,
      time: etTime
    };
  }

  checkCutoffAndUpdate() {
    const et = this.getEasternTime();
    const hour = et.time.getHours();
    const minutes = et.time.getMinutes();
    const isPastCutoff = (hour > 14) || (hour === 14 && minutes >= 0);
    
    if (this.lastCutoffState !== isPastCutoff) {
      console.log(`Cutoff state changed at ${et.display}`);
      this.lastCutoffState = isPastCutoff;
      this.render();
    }
  }

  switchRegion(region) {
    this.currentRegion = region;
    this.render();
  }
  
  getShippingOptions() {
    const et = this.getEasternTime();
    let dateKey = et.time.toISOString().split('T')[0];
    
    if (this.lastCutoffState) {
      const tomorrow = new Date(et.time);
      tomorrow.setDate(tomorrow.getDate() + 1);
      dateKey = tomorrow.toISOString().split('T')[0];
      et.time = new Date (tomorrow.toLocaleString('en-US', { timeZone: 'America/New_York' }));
    }
    
    //Whenever it can't find a delivery date from the override list, switch to the automated version
    /*const dates = this.deliveryDates[this.currentRegion][dateKey] || 
                  (this.currentRegion!='us'?this.deliveryDates[this.currentRegion][Object.keys(this.deliveryDates[this.currentRegion])[0]]
                  :[`${this.getDatesOffset(7)} - ${this.getDatesOffset(9)}`, `${this.getDatesOffset(5)} - ${this.getDatesOffset(6)}`, this.getDatesOffset(2), this.getDatesOffset(1)]);*/
    const dates = window.shippingInfo.get_shipping_info(this.currentRegion, et.time);
    
    
    switch(this.currentRegion) {
      case 'us':
        if(window.deliveryManualSettings != undefined){
          if(window.deliveryManualSettings.isManual == true){
              return [
                { name: 'Standard', price: '<div class="tiered-pricing">$3.95<br>Free Shipping $60+</div>', delivery: window.deliveryManualSettings.standardManual },
                { name: 'Expedited', price: '$5.95', delivery: window.deliveryManualSettings.expeditedManual },
                { name: '2-Day', price: window.deliveryManualSettings.twoDayShippingDeal == true?'<div class="tiered-pricing"><s>$8.95</s><br><b>FREE</b></div>':'$8.95', delivery: window.deliveryManualSettings.twoDayManual },
                { 
                  name: 'Overnight', 
                  price: '$17.95', 
                  delivery: window.deliveryManualSettings.overnightManual
                }
              ];
          }
        }
        return [
          { name: 'Standard', price: '<div class="tiered-pricing">$3.95<br>Free Shipping $60+</div>', delivery: dates["standard"] },
          { name: 'Expedited', price: '$5.95', delivery: dates["expedited"] },
          { name: '2-Day', price: window.deliveryManualSettings.twoDayShippingDeal?'<div class="tiered-pricing"><s>$8.95</s><br><b>FREE</b></div>':'$8.95', delivery: dates["twoDay"] },
          { 
            name: 'Overnight', 
            price: '$17.95', 
            delivery: dates["overnight"] 
          }
        ];
      case 'canada':
        return [
          { name: 'Standard', price: '$14.95', delivery: dates["standard"] },
          { name: 'Expedited', price: '$24.95', delivery: dates["expedited"] }
        ];
      default:
        return [
          { name: 'Standard', price: '$24.95', delivery: dates["standard"] },
          { name: 'Expedited', price: '$44.95', delivery: dates["expedited"] }
        ];
    }
  }

  render() {
    const et = this.getEasternTime();
    const isPastCutoff = this.lastCutoffState;
    const options = this.getShippingOptions();

    const html = `
      <div class="z-shipping-widget">
        <div class="z-shipping-header">
          <span class="z-header-text">Delivery Date Estimates</span>
        </div>

        <div class="z-tabs">
          <div class="z-tab ${this.currentRegion === 'us' ? 'active' : ''}" 
               onclick="window.deliveryCalc.switchRegion('us')">
            <span>🇺🇸 USA</span>
          </div>
          <div class="z-tab ${this.currentRegion === 'canada' ? 'active' : ''}"
               onclick="window.deliveryCalc.switchRegion('canada')">
            <span>🍁 Canada</span>
          </div>
          <div class="z-tab ${this.currentRegion === 'international' ? 'active' : ''}"
               onclick="window.deliveryCalc.switchRegion('international')">
            <span>🌎 International</span>
          </div>
        </div>

        ${this.currentRegion === 'us' ? `
          <div class="z-free-shipping-notice">
            Free standard shipping on orders over $60!
          </div>
        ` : ''}

        <table class="z-shipping-table">
          <thead>
            <tr>
              <th>Service</th>
              <th>Cost</th>
              <th>Estimated Delivery</th>
            </tr>
          </thead>
          <tbody>
            ${options.map(option => `
              <tr>
                <td class="z-service-name">${option.name}</td>
                <td class="z-service-price">${option.price}</td>
                <td class="z-delivery-date">${option.delivery}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>

        <div class="z-cutoff-notice">
          ⏰ Order by 2:00 PM ET ${isPastCutoff ? 'tomorrow' : 'today'} for these delivery dates
          <div class="z-current-time">Current time: ${et.display} ET</div>
        </div>
      </div>
    `;

    console.log(this.container);
    this.container = document.getElementById('z-delivery-calculator');
    this.container.innerHTML = html;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  console.log('Initializing delivery calculator...');
  window.deliveryCalc = new DeliveryCalculator();
});